export default function (state = null, action) {
    switch (action.type) {
        case 'SESSION':
            return action.payload;
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/services/session/reducer.js